import { useLingui } from "@lingui/react/macro";
import { TriangleAlert } from "lucide-react";

/** Under the stages, when a step is flagged: what the red icon is and what to do with it. */
export function CcpLegend() {
  const { t } = useLingui();
  return (
    <p className="flex items-center gap-1.5 text-xs text-(--color-text-secondary) print:hidden">
      <TriangleAlert className="size-3.5 text-(--color-danger-text)" aria-hidden />
      {t`Step has a warning label: click the icon to read it`}
    </p>
  );
}
